import {base} from '../config/api';

export function completeUrls(data) {
	return data.map(completeUrlsForItem);
}

export function completeUrlsForItem(item) {
	if(item.files !== null){
		item.files = completeUrlsForFile(item.files);
	}
	if(item.imageUrls !== null){
		item.imageUrls = item.imageUrls.map(image => base + image);
	}
	if(item.icons !== null){
		item.icons = item.icons.map(icon => ({
			id : icon.id,
			name: icon.name,
			url:  base + icon.url
		}));
	}
	return item;
}

export function completeUrlForSlider(data) {
	return data.map(sliderItem => {
		sliderItem.imageUrl = base + sliderItem.imageUrl;
		return sliderItem;
	});
}

export function completeUrlForArticleList(data) {
	return data.map(completeUrlForArticle);
}

export function completeUrlForArticle(article) {
	article.image = article.image!== null ? base + article.image : null;
	return article;
}

export function completeUrlsForFile(data) {
	return data.map(file => {
		if(!file.fileType.includes('TUTORIAL')){
			file.link = base + file.link;
		}
		return file;
	})
}

export function paginate (array, pageSize, pageNumber) {
	--pageNumber;
	return array.slice(pageNumber * pageSize, (pageNumber + 1) * pageSize);
}

export function endPage(array, pageSize) {
	let end = Math.floor(array.length / pageSize);
	end = array.length - (pageSize * end) > 0 ? end + 1 : end;
	return end;
}

export function getDateByLocaleFormat(timestamp, locale) {
	return (new Date(timestamp)).toLocaleDateString(locale === 'hu_HU' ? 'hu-HU' : 'en-GB');
}

export function getPageClassOfItemByCode(code) {
	return 'page__banner--' + code.replace(/_/g,'-').toLowerCase();
}


// WEBPACK FOOTER //
// ./src/util/utils.js